import { render, staticRenderFns } from "./SupervisionIndex.vue?vue&type=template&id=12a631f9&scoped=true&"
import script from "./SupervisionIndex.vue?vue&type=script&lang=js&"
export * from "./SupervisionIndex.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionIndex.vue?vue&type=style&index=0&id=12a631f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a631f9",
  null
  
)

export default component.exports